import React, { useState, useRef, useEffect } from 'react';
import { Subject, interval, timer } from 'rxjs';


import { takeLast, throttle, last, debounce, filter, repeat, mergeAll, concatMap, throttleTime } from 'rxjs/operators';
import SettingDialog from './SettingDialog';
import Text from './molecules/Tspan';

// const color = ['red', 'blue', 'green', 'yellow', 'magenta', 'cyan'];
const color = ['#e91e63', '#673ab7', '#2196f3', '#00bcd4', '#4caf50', '#ffeb3b', '#ff9800', '#795548', '#607d8b'];


interface Touch {
    id: number;
    color?: string;
    status: 'touched' | 'ready' | 'lucky',
    started: number;
    x: number;
    y: number;
}

const moveRxSubject = new Subject();

const refineTouch = (targetTouches: Array<Touch>, touches: Array<Touch>) => {
    const availableColors = color.filter(col => touches.filter((t: Touch) => t.color === col).length === 0);
    const ts: Array<Touch> = targetTouches.map(touch => {
        const found: Array<Touch> = touches.filter((t: Touch) => t.id === touch.id);
        if (found.length === 0) {
            const colIdx = Math.floor(Math.random() * 1000) % availableColors.length;
            const ret: Touch = {
                id: Number(touch.id),
                color: '' + availableColors.splice(colIdx, 1),
                status: 'touched',
                started: Date.now(),
                x: Number(touch.x),
                y: Number(touch.y)
            }
            return ret;
        } else {
            return {
                ...found[0],
                x: Number(touch.x),
                y: Number(touch.y)
            };
        }
    });
    return ts;
};
const getCountTime = (readyTime: number, count = 3.9): number => {
    const ct = (count - (Date.now() - readyTime) / 1000).toFixed(1);
    return Number(ct ? ct : 0);
}

// interface DataType {
//     status: 'wait' | 'ready' | 'done',
//     count: number,
//     readyTime: number,
//     touches: Array<Touch>
// }

type I18N_TYPE = 'draw_n_finger' | 'place_your_finger';
const getI18N_MSG = (key: I18N_TYPE, params: any[], lang: 'en' | 'ko', rnd: number): string => {
    let p = Array(10).fill('').map((o, i) => params.length > i && params[i] !== undefined ? params[i] : '');
    let [p0, p1, p2, p3, p4, p5, p6, p7, p8, p9] = p;

    const I18N_MSG: Array<{ key: I18N_TYPE, value: string, lang: 'en' | 'ko' }> = [
        { lang: 'en', key: 'draw_n_finger', value: `Draw ${p0} finger${p1}` },
        { lang: 'en', key: 'draw_n_finger', value: `Pick ${p0} finger${p1}` },
        { lang: 'en', key: 'draw_n_finger', value: `${p0} Winner${p1}` },
        { lang: 'en', key: 'draw_n_finger', value: `${p0} Loser${p1}` },

        { lang: 'ko', key: 'draw_n_finger', value: `손가락 ${p0}개 당첨!` },
        { lang: 'ko', key: 'draw_n_finger', value: `${p0}개 당첨!` },
        { lang: 'ko', key: 'draw_n_finger', value: `행운 ${p0}개!` },

        { lang: 'en', key: 'place_your_finger', value: `Place your fingers \n (${p0} / At least ${p1})` },
        { lang: 'en', key: 'place_your_finger', value: `Put your fingers on the screen \n (${p0} / At least ${p1})` },
        { lang: 'en', key: 'place_your_finger', value: `Who is gonna buy coffees? \n Let's put you guys' fingers here!\n (${p0} / At least ${p1})` },

        { lang: 'ko', key: 'place_your_finger', value: `최소 ${p1}개 손가락을 화면에 터치해주세요. \n ${p0}개 터치중` },
        { lang: 'ko', key: 'place_your_finger', value: `화면에 최소 ${p1}개 손가락을 올려주세요. \n ${p0}개 터치중` },
    ];

    const filtered = I18N_MSG.filter(o => o.key === key && o.lang === lang);
    if (filtered.length === 0) {
        return '';
    }
    const idx = Math.ceil(rnd === 0 ? 0.001 : rnd * filtered.length) - 1;
    return filtered[idx].value;
}


const MultiTouchChoice: React.FC = (props: any) => {
    const [lang, setLang] = useState<'en' | 'ko'>('en');
    useEffect(() => {
        const lslang = localStorage.getItem('lang');
        if (lslang && lslang !== null && ['en', 'ko'].indexOf(lslang) > -1) {
            setLang(lslang === 'en' ? 'en' : 'ko');
        } else {
            const _lang = ['ko'].indexOf(navigator.language) > -1 ? 'ko' : 'en'
            setLang(_lang);
            console.log('_lang', _lang);
        }
    }, []);

    const [rnd, setRnd] = useState<number>(0.1);
    useEffect(() => {
        setRnd(Math.random());
    }, [])
    const t = (key: I18N_TYPE, params: any[]): string => {
        return getI18N_MSG(key, params, lang, rnd);
    }

    const [targetCount, setTargetCount] = useState<number>(1);
    const [status, setStatus] = useState<'wait' | 'ready' | 'done'>('wait');
    const [touches, setTouches] = useState<Array<Touch>>([]);
    const [readyTime, setReadyTime] = useState<number>(0);
    const [readyCount, setReadyCount] = useState<number>(0);
    const [text, setText] = useState('');

    const [tnum, setTnum] = useState(0);
    useEffect(() => {
        // console.log(data, data.touches);
        if (touches.length > 0) {
            if (touches.filter(t => t.status === 'ready').length === touches.length && touches.length >= targetCount + 1) {
                if (readyTime === 0) {
                    setReadyTime(Date.now());
                    if (status !== 'ready') {
                        setStatus('ready');
                        setReadyCount(touches.length);
                    }
                } else {
                    // console.log(readyTime / 1000, Math.floor((Date.now() - readyTime) / 1000))
                    const timeCount = getCountTime(readyTime);
                    if (timeCount < 1 && readyTime !== 0 && status === 'ready') {
                        const allIds = touches.map((v, i) => i);
                        const selected: Array<number> = [];

                        for (let i = 0; i < targetCount; i++) {
                            const _rnd = Math.random()
                            const rnd = Math.floor(_rnd * allIds.length);
                            const sel = allIds.splice(rnd, 1);
                            sel.forEach(n => selected.push(n));
                            console.log('select', i, sel, selected.join(), allIds.join())
                        }
                        console.log(selected, allIds);

                        for (let i = 0; i < selected.length; i++) {
                            touches[selected[i]].status = 'lucky';
                        }

                        setTouches(touches);

                        setStatus('done');
                    }
                }
                if (readyCount !== touches.length && readyCount !== 0) {
                    setReadyTime(0);
                    setReadyCount(0);
                    setStatus('wait');
                }
            } else {
                const now = Date.now();
                let changed = false;
                const ts = touches.map(t => {
                    if (now - t.started > 1000 && t.status === 'touched') {
                        changed = true;
                        t.status = 'ready';
                    }
                    return { ...t };
                });
                if (changed) {
                    setTouches(ts);
                }
                if (ts.filter(t => t.status === 'ready').length !== touches.length && status === 'ready') {
                    setStatus('wait');
                    setReadyTime(0);
                    setReadyCount(0);
                }
            }
        } else if (status !== 'wait') {
            setStatus('wait');
            setReadyTime(0);
            setReadyCount(0);
        }
    }, [tnum]);


    const ref: React.RefObject<SVGSVGElement> = useRef<SVGSVGElement>(null);
    useEffect(() => {
        console.log(ref.current);
        if (ref.current) {
            const cur: any = ref.current
            cur.ongesturestart = (e: any) => {
                console.log('gesturestart');
                setText('gesturestart')
                e.stopPropagation();
                e.preventDefault();
            }
            cur.ongesturechange = (e: any) => {
                console.log('gesturechange');
                setText('gesturechange')
                e.stopPropagation();
                e.preventDefault();
            }
            cur.ongestureend = (e: any) => {
                console.log('gestureend');
                setText('gestureend')
                e.stopPropagation();
                e.preventDefault();
            }
        }

        const pipe$ = moveRxSubject.pipe(throttleTime(10));
        pipe$.subscribe((val: any) => {
            console.log('move', val, val.touches.map((t: Touch) => t.status));
            setTouches(refineTouch(val.original, val.touches));
        });

        // apply tnum effect
        interval(10).subscribe(setTnum);
    }, [])


    const getOriginalTouches = (e: any) => {
        const targetTouches: Array<Touch> = Object.keys(e.targetTouches).map((key: any) => {
            const touch = e.targetTouches[key];
            console.log(touch)
            return {
                id: Number(touch.identifier),
                started: Date.now(),
                status: 'touched',
                x: Number(touch.clientX),
                y: Number(touch.clientY)
            }
        });
        return targetTouches;
    }


    const handleClickIncreaseTargetCount = (e: any) => {
        console.log('start Target', e.target);
        e.preventDefault();
        if (targetCount < 9) {
            setTargetCount(targetCount + 1);
        }
    }
    const handleClickDecreaseTargetCount = (e: any) => {
        e.preventDefault();
        if (targetCount > 1) {
            setTargetCount(targetCount - 1);
        }
    }

    const handleClickReset = () => {
        console.log(handleClickReset);
        setStatus('wait');
        setReadyTime(0);
        setReadyCount(0);
        setTouches([]);
    }



    const handleTouchStart = (e: any) => {
        // e.preventDefault();

        if (status === 'done') {
            return;
        }
        setTouches(refineTouch(getOriginalTouches(e), touches));
    }
    const handleTouchEnd = (e: any) => {
        // e.preventDefault();
        if (status === 'done') {
            return;
        }
        setTouches(refineTouch(getOriginalTouches(e), touches));
    }
    const handleTouchMove = (e: any) => {
        // e.preventDefault();
        if (status === 'done') {
            return;
        }
        moveRxSubject.next({ original: getOriginalTouches(e), touches: touches });
    }



    const handleClickOpenSetting = () => {
        console.log('openSetting');
    }


    const _wid = window.innerWidth / 2;
    const _wih = window.innerHeight / 9;
    const cbx = _wid < 70 ? 70 : _wid;
    const cby = _wih < 70 ? 70 : _wih;
    const cr = Math.floor(_wid / 5) + 20;


    return <svg ref={ref} style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white' }}
        // viewBox="0 0 100 100"
        className="noselect"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
    >

        {(status === 'done') &&
            <g>
                <g >
                    <rect x={cbx - 50} y={cby - 65} width="100" height="45" fill="lightgray" rx="15"
                        onClick={handleClickReset} onTouchStart={(e: any) => e.stopPropagation()} />
                    <text x={cbx} y={cby - 32} text-anchor="middle" style={{ fontSize: '30px', pointerEvents: 'none' }}>Reset</text>
                </g>
            </g>
        }

        {status === 'wait' &&
            <g onTouchStart={(e: any) => e.stopPropagation()} onTouchMove={(e: any) => e.stopPropagation()} >
                {/* <g><circle cx={cbx} cy={cby - 10 - 35} fill="lightgray" r="25"
                    onClick={handleClickOpenSetting} onTouchStart={(e: any) => {}} />
                    <text x={cbx} y={cby + 7 - 35} text-anchor="middle" style={{ fontSize: '60px', pointerEvents: 'none' }}>&#8859;</text>
                </g> */}

                <g><circle cx={cbx - 100} cy={cby - 10} fill="lightgray" r="25"
                    onClick={handleClickIncreaseTargetCount} onTouchStart={(e: any) => e.stopPropagation()} />
                    <text x={cbx - 100} y={cby + 6} text-anchor="middle" style={{ fontSize: '60px', pointerEvents: 'none' }}>+</text>
                </g>
                <g><circle cx={cbx + 100} cy={cby - 10} fill="lightgray" r="25"
                    onClick={handleClickDecreaseTargetCount} onTouchStart={(e: any) => e.stopPropagation()} />
                    <text x={cbx + 100} y={cby + 8} text-anchor="middle" style={{ fontSize: '60px', pointerEvents: 'none' }}>-</text>
                </g>
                {/* <text x={cbx} y={cby} text-anchor="middle"> {t('draw_n_finger', [targetCount, targetCount !== 1 ? 's' : ''])}</text> */}
                <Text x={cbx} y={cby} style={{ textAnchor: "middle" }}> {t('draw_n_finger', [targetCount, targetCount !== 1 ? 's' : ''])}</Text>
                <Text x={cbx} y={window.innerHeight / 2} style={{ textAnchor: "middle" }}>
                    {t("place_your_finger", [touches.length, targetCount + 1])}
                </Text>
            </g>
        }
        {
            status === 'ready' && <g>
                <text x={cbx} y={cby + 75} text-anchor="middle" style={{ fontSize: '70px' }}>{Math.floor(getCountTime(readyTime))}</text>
            </g>
        }

        {/*  */}
        {
            touches.map((t: Touch) => {
                return <g key={t.id} style={{ transform: 'translate(' + t.x + 'px, ' + t.y + 'px)' }}>
                    {t.status === 'touched' && status !== 'done' && <circle cx={0} cy={0} fill={'#eeeeee'} r={cr + Math.floor((Date.now() - t.started) / 100) + "px"} />}
                    {t.status === 'ready' && status !== 'done' && <circle cx={0} cy={0} fill={'lightgray'} r={cr + 10 + 'px'} />}
                    {/* {t.status === 'lucky' && <circle cx={0} cy={0} fill={'gray'} r={cr +'60px'} />} */}
                    {t.status === 'lucky' && <g>
                        <circle className='luckyCircle' cx={0} cy={0} fill={t.color} r={cr + 50 + 'px'} />
                        <circle cx={0} cy={0} fill={'white'} r={cr + 10 + 'px'} />
                    </g>}
                    {(t.status === 'lucky' || status !== 'done') && <circle cx={0} cy={0} fill={t.color} r={cr + 'px'} />}
                </g>
            })
        }
        {/* // TODO Setting dialog */}
        <SettingDialog open={false} onClose={() => { }} />
    </svg >
}


export default MultiTouchChoice